module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/004-oman-5ea42547b83245d9b2c34cf5467bb03e.svg";